"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WAKE_WORD = exports.DEFAULT_LANGUAGE = void 0;
exports.DEFAULT_LANGUAGE = 'fr-FR';
exports.DEFAULT_WAKE_WORD = 'Bonjour';
